// extracted by mini-css-extract-plugin
module.exports = {"photoDetail":"detail_photoDetail__1XITd","photos":"detail_photos__3lIJ2","photo":"detail_photo__uOEF3"};